/* global angular*/

import './style.less';
import moment from 'moment';
import { get } from 'lodash';

export default function($log, $state, $stateParams) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.activate = activate;

  vm.profile_uid = $stateParams.employeeID || $stateParams.id;

  vm.adminCss = $state.current.name === 'app.admin.employees.employee.compliance';

  vm.colorDict = {
    'Exceeding Benchmark': 'primary',
    'Behind Benchmark': 'warning',
    'In Danger': 'danger',
    'At Risk': 'danger'
  };

  vm.getAnnualRequirement = (cycles, selected, index) => {
    return get(
      cycles[selected],
      `cycle_limiter.min.annual.${index}.hours`,
      cycles[selected].cycle_limiter.annual.hours
    );
  };

  vm.getAnnualKey = cycleDate => {
    const today = new moment();
    const date = new moment(cycleDate);

    while (date.diff(today, 'years', true) > 1) {
      date.subtract(1, 'years');
    }

    return `hours_${date.year()}`;
  };

  function activate() {
    $log.debug('Compliance Track Gauges Activated');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/complianceTrackerGauges/controller.js